import { Component, OnDestroy, OnInit } from '@angular/core';
import { DashboardService } from '../../dashboard/dashboard.service';
import { AlarmeListComponent } from '../../_widgets/alarme-list/alarme-list.component';
import { Store } from '@ngrx/store';
import { MainStoreState } from '../../../_store/mainStoreState';
import {
  getAlarmesWithHighCriticity,
  loadAlarmesAction,
} from '../../../_store/AlarmeStore/alarme.store';
import { AlarmeService } from '../../../_services/http/alarme.service';
import { BehaviorSubject, Subscription } from 'rxjs';
import { ConfigService } from '../../../_services/local/config.service';

@Component({
  selector: 'app-alarm',
  templateUrl: './alarm.component.html',
  styleUrls: ['./alarm.component.scss'],
})
export class AlarmComponent implements OnInit, OnDestroy {
  private channel = new BroadcastChannel('alarme-list');
  private totaux: { totalNouvelle: number; totalAcquitte: number } | undefined;
  private storeSubscription!: Subscription;

  readonly colors = this.configService.Config.colors.sousSystemes;

  isLoading$ = new BehaviorSubject<boolean>(true);
  circleColor$: BehaviorSubject<string> = new BehaviorSubject<string>('gray');
  summary$: BehaviorSubject<string> = new BehaviorSubject<string>('');


  calculateColor(): string {
    if (this.totaux) {
      if (this.totaux.totalNouvelle === 0 && this.totaux.totalAcquitte === 0) {
        return this.colors['1'];
      } else if (this.totaux.totalNouvelle === 0) {
        return this.colors['2'];
      } else if (this.totaux.totalNouvelle > 0) {
        return this.colors['3'];
      }
    }

    return 'gray';
  }

  calculateSummary(): string {
    let result = '';

    if (this.totaux) {
      result = `${this.totaux.totalNouvelle}/${
        this.totaux.totalNouvelle + this.totaux.totalAcquitte
      }`;
    }

    return result;
  }

  constructor(
    private store: Store<MainStoreState>,
    private service: AlarmeService,
    private dbService: DashboardService,
    private configService: ConfigService,
  ) {
  }

  ngOnInit(): void {
    this.storeSubscription = this.store
      .select(getAlarmesWithHighCriticity)
      .subscribe((data) => {
        this.totaux = data;
        setTimeout(() => {
          this.circleColor$.next(this.calculateColor());
          this.summary$.next(this.calculateSummary());
          this.isLoading$.next(false);
        });
      });

    this.store.dispatch(loadAlarmesAction());
    this.service.refreshHubConnection();
  }

  ngOnDestroy(): void {
    this.storeSubscription.unsubscribe();
  }

  openAlarmWidget(): void {
    if (this.dbService.isWidgetOpen('AlarmeListComponent')) {
      this.channel.postMessage({
        type: 'select',
      });
    } else {
      this.dbService.openWidget('AlarmeListComponent');
    }
  }
}
